import { AreaItem } from 'features/areas/types/areas.types'
import { useEffect } from 'react'
import { FieldValues, UseFormReset } from 'libs/form'

type UsePopulateAreaProps = {
	data: AreaItem | undefined
	reset: UseFormReset<FieldValues>
}

export const usePopulateArea = ({ data, reset }: UsePopulateAreaProps) => {
	useEffect(() => {
		if (data) {
			reset({
				number: data.number,
				boothType: { label: data.booth_type_name, value: data.booth_type },
				is_active: data.is_active
			})
		}
	}, [data])
}
